import { useQuery, useMutation } from '@tanstack/react-query'
import { apiClient, authHeader } from '../lib/api'
import type { Subscription } from '@tnf-recruit/shared'
import { useAuth } from './useAuth'

export function useSubscription(options?: { enabled?: boolean }) {
  const { getAccessToken } = useAuth()

  const subscription = useQuery({
    queryKey: ['subscription'],
    enabled: options?.enabled !== false,
    queryFn: async () => {
      const token = await getAccessToken()
      const { data } = await apiClient.get('/payments/subscription', authHeader(token))
      return data.data as Subscription | null
    },
  })

  const createCheckout = useMutation({
    mutationFn: async (body: { successUrl: string; cancelUrl: string }) => {
      const token = await getAccessToken()
      const { data } = await apiClient.post(
        '/payments/create-checkout-session',
        body,
        authHeader(token)
      )
      return data.data as { sessionId: string; url: string }
    },
  })

  const createPortalSession = useMutation({
    mutationFn: async () => {
      const token = await getAccessToken()
      const { data } = await apiClient.post(
        '/payments/create-portal-session',
        {},
        authHeader(token)
      )
      return data.data as { url: string }
    },
  })

  return { subscription, createCheckout, createPortalSession }
}
